export default __webpack_public_path__ + "static/17-c722887fbd8ae05fb66f9e4e393a4f1c.png";